export const GET_USER_TOUR_REQUEST = 'GET_USER_TOUR_REQUEST';
export const GET_USER_TOUR_SUCCESS = 'GET_USER_TOUR_SUCCESS';
export const GET_USER_TOUR_FAILURE = 'GET_USER_TOUR_FAILURE';

export const POST_USER_TOUR_REQUEST = 'POST_USER_TOUR_REQUEST';
export const POST_USER_TOUR_SUCCESS = 'POST_USER_TOUR_SUCCESS';
export const POST_USER_TOUR_FAILURE = 'POST_USER_TOUR_FAILURE';
